// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7395) return "css/design_system-0bfcf53c5131c14f8b2f.css";
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"2508":"a6e6425876428eb29d6c","2546":"e613c7cd214863780c37","2822":"cf1204f290f751d3ff23","6862":"2d63da2d3c6b291a5a60","9127":"f3797b473bbf7fc51654","9725":"5812d2783dcee559c5c5"}[chunkId] + ".css";
};